import React, { useEffect, useState } from 'react';

import { Button, Stack, TextField } from '@mui/material';
import { GridFilterInputValueProps } from '@mui/x-data-grid-pro';

import { MAX_PROPERTY_NAME_LENGTH } from './utils';

// Every search is a BigQuery scan, so it runs on Search or Enter rather than on each keystroke.
export default function PropertyNameFilterInput({ item, applyValue, focusElementRef }: GridFilterInputValueProps) {
  const applied = typeof item.value === 'string' ? item.value : '';
  const [search, setSearch] = useState(applied);

  useEffect(() => setSearch(applied), [applied]);

  const changed = search.trim() !== applied;
  const submit = () => changed && applyValue({ ...item, value: search.trim() });

  return (
    <Stack direction="row" alignItems="flex-end" spacing={1}>
      <TextField
        variant="standard"
        label="Value"
        placeholder="Hotel name"
        value={search}
        onChange={(event) => setSearch(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            submit();
          }
        }}
        inputRef={focusElementRef}
        slotProps={{ htmlInput: { maxLength: MAX_PROPERTY_NAME_LENGTH } }}
        fullWidth
      />
      <Button size="small" variant="contained" onClick={submit} disabled={!changed}>
        Search
      </Button>
    </Stack>
  );
}
